import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

import wrapper from 'redux/store'
import { getCollectionAllCall, getCollectionCall } from 'api/calls'
import { withRedis } from 'api/callConstructor'
import { redis } from 'utils/redis'

const CollectionPage = dynamic(() => import('modules/collections/CollectionPage/CollectionPage'))
const HeadTags = dynamic(() => import('components/app/HeadTags/HeadTags'))

const CollectionContainer = props => {
  const {
    metaInfo: { title, description, image, metaDescriptionImage, metaTitle },
    softDelete
  } = props

  const { isLogged } = useSelector(({ auth }) => auth)

  const updatedProps = {
    ...props,
    isLogged
  }

  return (
    <>
      <HeadTags
        title={metaTitle || title}
        description={description}
        thumbnail={metaDescriptionImage || image}
        softDelete={softDelete}
      />
      <CollectionPage {...updatedProps} />
    </>
  )
}

CollectionContainer.propTypes = {
  metaInfo: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    image: PropTypes.string,
    metaDescriptionImage: PropTypes.string,
    metaTitle: PropTypes.string
  }),
  softDelete: PropTypes.bool
}

CollectionContainer.defaultProps = {
  metaInfo: {
    title: '',
    description: '',
    image: '',
    metaTitle: '',
    metaDescriptionImage: ''
  },
  softDelete: false
}

export const getStaticPaths = async () => {
  // Call to get collections
  const collections = await withRedis(redis, getCollectionAllCall(), '/collections/slug')
  // if (!collections.success)
  //   throwSentryError(
  //     `Error: API URL: https://cms.moneymade.io/api/collections. ${collections.status} ${collections.message}`
  //   )

  // Generate collections paths to prerender routes
  const paths = collections.success ? collections.result?.map(({ slug }) => ({ params: { slug } })) : []

  return {
    paths,
    fallback: true
  }
}

export const getStaticProps = wrapper.getStaticProps(async ({ params: { slug } }) => {
  // Call to get collections
  const collections = await withRedis(redis, getCollectionAllCall(), `/collections/${slug}`)
  // if (!collections.success)
  //   throwSentryError(
  //     `Error: API URL: https://cms.moneymade.io/api/collections. ${collections.status} ${collections.message}`
  //   )

  const currentCollection = collections.result?.find(({ slug: localSlug }) => localSlug === slug) || {}

  // Call to get collections
  const collection = await withRedis(redis, getCollectionCall(slug), `/collections/${slug}`)
  // if (!collection.success)
  //   throwSentryError(
  //     `Error: API URL: https://cms.moneymade.io/api/collections/${slug}. ${collection.status} ${collection.message}`
  //   )

  return {
    notFound: collection.result?.message,
    props: {
      metaInfo: currentCollection,
      collection: collection.result,
      collections: collections.result,
      softDelete: collections?.result?.publishedStatus === 'draft',
      collectionSlug: slug
    },
    revalidate: 600 // 10 min
  }
})

export default CollectionContainer
